import { Nullable } from 'global';
import { InventoryItemStatus } from '@trnsact/trnsact-shared-types';

/**
 * DR-10802: a unit the dealer is still sourcing, created in Deal Builder so it can be quoted. The API hides it
 * from every other inventory surface.
 *
 * TODO(DR-10802): replace with InventoryItemStatus.Prospective once @trnsact/trnsact-shared-types is republished
 * from api-server with the new enum value.
 */
export const PROSPECTIVE_INVENTORY_STATUS = 'PROSPECTIVE' as InventoryItemStatus;

export const isProspectiveInventoryStatus = (status?: Nullable<string>) => status === PROSPECTIVE_INVENTORY_STATUS;

/** Statuses a rep can pick by hand. Prospective is set only by Deal Builder's "Add Prospective Unit". */
export const SELECTABLE_INVENTORY_ITEM_STATUSES = Object.values(InventoryItemStatus).filter(
  status => !isProspectiveInventoryStatus(status)
);
